import { render, staticRenderFns } from "./MenteeChat.vue?vue&type=template&id=2d0b89a6"
import script from "./MenteeChat.vue?vue&type=script&lang=js"
export * from "./MenteeChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports